import React, { useEffect, useRef } from 'react';

import { useAuthContext } from 'state/auth';
import { useIsLoyaltyEnabled } from 'state/loyalty/hooks/use-is-loyalty-enabled';
import { useLoyaltyUser } from 'state/loyalty/hooks/use-loyalty-user';

import { LoyaltyOptInModalContentView } from './loyalty-opt-in-modal-content.view';
import SuccessAnimation from './success-animation';
import { useLoyaltyOptIn } from './use-loyalty-opt-in';

export default () => {
  const loyaltyEnabled = useIsLoyaltyEnabled();
  const { loyaltyUser, loading: loyaltyLoading } = useLoyaltyUser();
  const { user, currentUserSession } = useAuthContext();
  const {
    dialogProps,
    isCompleted,
    loadingData,
    hasData,
    isDismissed,
    excludeForCurrentPath,
    loyaltyUserCreated,
  } = useLoyaltyOptIn();

  const prevIsCompletedRef = useRef(false);

  useEffect(() => {
    prevIsCompletedRef.current = isCompleted;
  }, [isCompleted]);
  const shouldShowAnimation = !prevIsCompletedRef.current && isCompleted;

  const noContentData = !hasData && !loadingData;

  if (
    !loyaltyEnabled ||
    isDismissed ||
    noContentData ||
    loadingData ||
    excludeForCurrentPath ||
    loyaltyLoading
  ) {
    return null;
  }

  if (shouldShowAnimation) {
    return <SuccessAnimation />;
  }

  if (!user || loyaltyUser || (user.loyaltyId && !loyaltyUserCreated)) {
    return null;
  }

  const sessionEmail = currentUserSession?.getIdToken?.().payload.email;
  const gqlEmail = user?.details?.email;

  if (sessionEmail !== gqlEmail) {
    return null;
  }

  return <LoyaltyOptInModalContentView dialogProps={dialogProps} />;
};
